// extracted by mini-css-extract-plugin
export default {"body":"styles_body__qVos+","showMoreButton":"styles_showMoreButton__j72V1"};